import React, { useEffect, useState } from "react";
import MainHeader from "../../Components/MainHeader/MainHeader";
import styles from "./Gallery.module.scss";
import { TabsProps, Tabs, Row, Col, Breadcrumb } from "antd";
import { TabInfo } from "./TabInfo";
import InvestImg from '@assets/KPMG/Invest.png';
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { WrapperLayout } from '~/Components/WrapperLayout/WrapperLayout';
import KnowledgeHubImg from '@assets/KPMG/KnowledgeHub.png';
import { ThoughtLeadership } from "./ThoughtLeadership";

export const Gallery: React.FC = () => {
  const navigate = useNavigate();
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: `Industry 1`,
      children: <TabInfo type="investment" />,
    },
    {
      key: "2",
      label: `Industry 2`,
      children: <TabInfo type="marketplace" />,
    },
    {
      key: "3",
      label: `Industry 3`,
      children: <TabInfo type="ecg" />,
    },
    {
      key: "4",
      label: `Industry 4`,
      children: <TabInfo type="ecg" />,
    },
  ];

  // const menuProps = {
  //     items,
  //     onClick: handleMenuClick,
  // };

  return (
    <>
      <WrapperLayout
        title={"Gallery"}
        text={
          "Transform your buildings into smarter and greener by bringing seamless connectivity from floor to floor. Harness the power of data collection to unlock valuable insights that will propel the business forward."
        }
        image={InvestImg}

      >
        <Row className="gallery">
          <Col lg={24}>
            <div style={{ margin: "1.5rem 0 0 0" }}>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Icon
                    icon="ic:outline-home"
                    height="20"
                    onClick={() => navigate("/")}
                    style={{
                      margin: "auto",
                      color: styles.strawberry,
                      cursor: "pointer",
                    }}
                  />
                </Breadcrumb.Item>
                <Breadcrumb.Item>Gallery</Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <div style={{ marginTop: 10 }}>
              {/* <Tabs defaultActiveKey="1" items={items} /> */}
              <ThoughtLeadership />
            </div>
          </Col>
        </Row>
      </WrapperLayout>
    </>
  );
};
